import InfoList from "../../InfoList";
import { MdOutlineBusiness } from "react-icons/md";
import { formatFromJsonDate } from "../../../dateConfig";
import { getNullSafeLabel } from "../../../helper";
import StatusLabel from "../../input/StatusLabel";
import React, { useEffect, useState } from "react";
import { getJobLocationTimeUpdates } from "../../../api/missioncontrolApi";

const MoreInfoJob = ({ jobInfo }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [startLocationArrival, setStartLocationArrival] = useState(null);
  const [endLocationArrival, setEndLocationArrival] = useState(null);
  const [startLocationDeparture, setStartLocationDeparture] = useState(null);
  const [endLocationDeparture, setEndLocationDeparture] = useState(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const startLocationtimeUpdateDetails = await getJobLocationTimeUpdates(
        jobInfo?.jobId,
        jobInfo?.startLocId,
      );
      const endLocationtimeUpdateDetails = await getJobLocationTimeUpdates(
        jobInfo?.jobId,
        jobInfo?.endLocId,
      );

      setStartLocationArrival(
        startLocationtimeUpdateDetails &&
          startLocationtimeUpdateDetails.length > 0
          ? startLocationtimeUpdateDetails[0].rtuArrivalTime
            ? formatFromJsonDate(
                startLocationtimeUpdateDetails[0].rtuArrivalTime,
              )
            : "N/A"
          : "N/A",
      );

      setStartLocationDeparture(
        startLocationtimeUpdateDetails &&
          startLocationtimeUpdateDetails.length > 0
          ? startLocationtimeUpdateDetails[0].rtuDepartureTime
            ? formatFromJsonDate(
                startLocationtimeUpdateDetails[0].rtuDepartureTime,
              )
            : "N/A"
          : "N/A",
      );

      setEndLocationArrival(
        endLocationtimeUpdateDetails && endLocationtimeUpdateDetails.length > 0
          ? endLocationtimeUpdateDetails[0].rtuArrivalTime
            ? formatFromJsonDate(endLocationtimeUpdateDetails[0].rtuArrivalTime)
            : "N/A"
          : "N/A",
      );

      setEndLocationDeparture(
        endLocationtimeUpdateDetails && endLocationtimeUpdateDetails.length > 0
          ? endLocationtimeUpdateDetails[0].rtuDepartureTime
            ? formatFromJsonDate(
                endLocationtimeUpdateDetails[0].rtuDepartureTime,
              )
            : "N/A"
          : "N/A",
      );

      setIsLoading(false);
    })();
  }, [jobInfo?.endLocId, jobInfo?.jobId, jobInfo?.startLocId]);

  return (
    <InfoList
      Icon={MdOutlineBusiness}
      iconParams={{ size: 20 }}
      content={[
        {
          title: "Job Code",
          value: getNullSafeLabel(jobInfo, "jobCode"),
        },
        {
          title: "Request Code",
          value: getNullSafeLabel(jobInfo, "reqCode"),
        },
        {
          title: "Requesting Customer",
          value: getNullSafeLabel(jobInfo, "customerName"),
        },
        {
          title: "Invoicing Customer",
          value: getNullSafeLabel(jobInfo, "billinCustomer"),
        },
        {
          title: "Billing Customer",
          value: getNullSafeLabel(jobInfo, "invoicingCustomer"),
        },
        {
          title: "Request By",
          value: getNullSafeLabel(jobInfo, "createdBy"),
        },
        {
          title: "Request Date",
          value: jobInfo
            ? jobInfo.createdDate
              ? formatFromJsonDate(jobInfo.createdDate)
              : "N/A"
            : "N/A",
        },
        {
          title: "Approved By",
          value: getNullSafeLabel(jobInfo, "reqApprovedBy"),
        },
        {
          title: "Approved Date",
          value: jobInfo
            ? jobInfo.reqApprovedDate
              ? formatFromJsonDate(jobInfo?.reqApprovedDate)
              : "N/A"
            : "N/A",
        },
        {
          title: "Start Location",
          value: getNullSafeLabel(jobInfo, "startLocation"),
        },
        {
          title: "Start Location Arrival",
          value: isLoading ? "Loading..." : startLocationArrival,
        },
        {
          title: "Start Location Departure",
          value: isLoading ? "Loading..." : startLocationDeparture,
        },
        {
          title: "End Location",
          value: getNullSafeLabel(jobInfo, "endLocation"),
        },
        {
          title: "End Location Arrival",
          value: isLoading ? "Loading..." : endLocationArrival,
        },
        {
          title: "End Location Departure",
          value: isLoading ? "Loading..." : endLocationDeparture,
        },
        {
          title: "Current Status",
          value: (
            <StatusLabel
              status={jobInfo?.statusName}
              color={jobInfo?.statusColor}
            />
          ),
        },
      ]}
      title={"Job Info"}
      singleColumn={true}
    />
  );
};

export default MoreInfoJob;
